export default __webpack_public_path__ + "static/media/tcs.259867ea.png";